import type { LegacyFairListNumericRouteParams } from '~/utils/fairSemanticListing'

/** 形如 `/exhibition-16-0-9999-0-0-0-1/` 或 `/seo/exhibition-…`（可选末尾 `/`） */
export const LEGACY_FAIR_LIST_NUMERIC_PATH =
  /^\/(?:seo\/)?exhibition-(\d+)-(\d+)-(\d+)-(\d+)-(\d+)-(\d+)-(\d+)\/?$/i

export function normalizeFairListPathname(pathname: string): string {
  return (pathname || '').split('?')[0].replace(/\/+/g, '/') || '/'
}

/** 中文站旧列表 URL（需 301），不含 `/exhibition/ticket/`、`:id.html` 等子路径 */
export function isLegacyFairListPathNeeding301(pathname: string): boolean {
  const path = normalizeFairListPathname(pathname)
  if (path === '/exhibition' || path === '/exhibition/') return true
  if (path === '/seo/exhibition' || path === '/seo/exhibition/') return true
  return LEGACY_FAIR_LIST_NUMERIC_PATH.test(path)
}

export function parseLegacyFairListNumericPath(pathname: string): LegacyFairListNumericRouteParams | null {
  const path = normalizeFairListPathname(pathname)
  if (path === '/exhibition' || path === '/exhibition/' || path === '/seo/exhibition' || path === '/seo/exhibition/') {
    return { f: 0, s: 0, g: 9999, p: 0, c: 0, t: 0, page: 1 } // 全球默认七段
  }
  const m = LEGACY_FAIR_LIST_NUMERIC_PATH.exec(path)
  if (!m) return null
  // exhibition-{f}-{s}-{g}-{p}-{c}-{t}-{page}
  const [, f, s, g, p, c, t, page] = m
  return { f, s, g, p, c, t, page }
}
